import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Edit2, Trash2 } from "lucide-react";

export default function AdminDevotionals() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ verse: "", reference: "", text: "", image_url: "", date: "" });
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/devotionals").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);
  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/devotionals/${editing}`, form);
      else await api.post("/devotionals", form);
      toast.success("Salvo");
      setForm({ verse: "", reference: "", text: "", image_url: "", date: "" });
      setEditing(null); load();
    } catch (err) { toast.error(err.response?.data?.detail || "Erro"); }
  };
  const del = async (id) => {
    if (!confirm("Excluir?")) return;
    await api.delete(`/devotionals/${id}`); toast.success("Excluído"); load();
  };
  const edit = (d) => { setForm({ ...d }); setEditing(d.id); };

  return (
    <div className="space-y-6">
      <div>
        <div className="label">Palavra</div>
        <h1 className="font-display text-3xl sm:text-4xl font-black mt-2">Devocionais</h1>
      </div>
      <form onSubmit={save} className="ci-card p-6 space-y-4" data-testid="admin-devotional-form">
        <div><label className="label">Versículo</label><textarea rows={2} required value={form.verse} onChange={(e)=>setForm({...form, verse:e.target.value})} className="ci-input mt-1 resize-none"/></div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="label">Referência</label><input required placeholder="Ex: João 3:16" value={form.reference} onChange={(e)=>setForm({...form, reference:e.target.value})} className="ci-input mt-1"/></div>
          <div><label className="label">Data</label><input type="date" value={form.date?.slice(0,10) || ""} onChange={(e)=>setForm({...form, date:e.target.value})} className="ci-input mt-1"/></div>
        </div>
        <div><label className="label">Texto / Reflexão</label><textarea rows={4} value={form.text} onChange={(e)=>setForm({...form, text:e.target.value})} className="ci-input mt-1 resize-none"/></div>
        <div><label className="label">URL da imagem (opcional)</label><input value={form.image_url || ""} onChange={(e)=>setForm({...form, image_url:e.target.value})} className="ci-input mt-1"/></div>
        <div className="flex gap-3">
          <button type="submit" className="btn-primary"><Plus size={16}/> {editing ? "Atualizar" : "Publicar"}</button>
          {editing && <button type="button" onClick={()=>{setEditing(null); setForm({verse:"", reference:"", text:"", image_url:"", date:""});}} className="btn-ghost">Cancelar</button>}
        </div>
      </form>
      <div className="grid gap-3 md:grid-cols-2">
        {list.map((d)=>(
          <div key={d.id} className="ci-card p-5">
            <div className="label">{d.reference}</div>
            <blockquote className="mt-2 font-display text-lg">"{d.verse}"</blockquote>
            <p className="mt-2 text-sm text-slate-400 line-clamp-3">{d.text}</p>
            <div className="mt-3 flex gap-2">
              <button onClick={()=>edit(d)} className="btn-ghost text-xs py-1.5 px-3"><Edit2 size={12}/></button>
              <button onClick={()=>del(d.id)} className="btn-ghost text-xs py-1.5 px-3 border-red-500/30 text-red-300"><Trash2 size={12}/></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
